export default {
	"1": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha producido un error general"
		},
		"ca": {
			titulo: "Error",
			cuerpo: "S'ha produït un error general"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "A general error has occurred"
		}
	},
	"2": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha perdido la sesión"
		},
		"ca": {
			titulo: "Error",
			cuerpo: "S'ha perdut la sessió"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Session has expired"
		}
	},
	"3": {
		"categoria": 'important',
		"es": {
			"titulo": "Error",
			"cuerpo": "El usuario no es válido"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'usuari no és vàlid"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Invalid user"
		}
	},
	"4": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se ha encontrado la oferta"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No s'ha trobat l'oferta"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Offer not found"
		}
	},
	"6": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a empleo"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'oferta s'adreça a ocupació"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "The offer is aimed at employment"
		}
	},
	"7": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta va dirigida a prácticas"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'oferta s'adreça a pràctiques"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "The offer is aimed at internships"
		}
	},
	"8": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El dato existía previamente"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "La dada existia prèviament"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Data already existed"
		}
	},
	"9": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El usuario se encuentra bloqueado"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'usuari es troba blocat"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "User is blocked"
		}
	},
	"10": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya es candidato/a a la oferta"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Ja sou candidat/a a l'oferta"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "You have already applied for this offer"
		}
	},
	"11": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Falta documentación necesaria"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Falta documentació necessària"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Required documentation is missing"
		}
	},
	"12": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Se ha producido un error enviando el email"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "S'ha produït un error a l'hora d'enviar el correu"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "An error occurred while sending mail"
		}
	},
	"13": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede gestionar la oferta"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No podeu gestionar l'oferta"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "You are not allowed to manage the offer"
		}
	},
	"14": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede pasar al estado seleccionado desde el actual"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No podeu passar a l'estat seleccionat des de l'actual"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "The selected status change is not permitted from the current state"
		}
	},
	"15": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Faltan datos obligatorios"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Falten dades obligatòries"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Missing required fields"
		}
	},
	"16": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Hay otro usuario con ese ID"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Hi ha un altre usuari amb aquest ID"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "That ID is already assigned to another user"
		}
	},
	"17": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta porque se solapa con su práctica"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No podeu inscriure-us a l'oferta perquè coincideix amb les pràctiques"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "You cannot enroll in this course because it overlaps with your internship"
		}
	},
	"18": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta, es para estudiantes de grado"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No podeu inscriure-us a l'oferta, és per a estudiants de grau"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "You cannot enroll in this offer; it is intended for undergraduate students"
		}
	},
	"19": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede inscribirse a la oferta, es para estudiantes de postgrado"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No podeu inscriure-us a l'oferta, és per a estudiants de postgrau"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "You cannot enroll in this offer; it is intended for postgraduate students"
		}
	},
	"20": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No tiene servicio de empleo"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No té servei d'ocupació"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Employment service is not available for this profile"
		}
	},
	"21": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No tiene servicio de prácticas"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No té servei de pràctiques"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Internship service is not available for this profile"
		}
	},
	"22": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No está identificado como UTP ni como UTE"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No estau identificat com a UTP ni com a UTE"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "You are not identified as UTP or UTE"
		}
	},
	"23": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No apareces matriculado de prácticas ponte en contacto con nosotros para solucionarlo"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No apareixeu matriculat de pràctiques, posau-vos en contacte amb nosaltres per solucionar-ho"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Internship enrollment not found. please contact us to solve the issue"
		}
	},
	"24": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Hay un problema con su empresa. Póngase en contacto con el administrador"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Hi ha un problema amb la vostra empresa. Posau-vos en contacte amb l'administrador"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "There is a problem with your Company. Please contact the administrator"
		}
	},
	"25": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La oferta ya tienen un gestor asociado y no puede editarse, póngase en contacto con él"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'oferta ja té un gestor/a associat i no pot editar-se. Posau-vos en contacte amb ell/a."
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "This offer already has an assigned manager and cannot be modified. please contact the assigned manager"
		}
	},
	"26": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se han encontrado estudios asociados a tu perfil. Por favor acude a secretaría de alumnos/as para actualizar tu información"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No s'han trobat estudis associats al vostre perfil. Si us plau, acudiu a secretaria d'alumnes per actualitzar la vostra informació"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "No studies found for your profile. please contact the student office to update your information"
		}
	},
	"27": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Por favor revisa los Datos de la Práctica, la fecha de inicio debe ser anterior a la fecha de finalización de las prácticas."
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Si us plau, revisau les dades de les pràctiques. La data d'inici ha de ser anterior a la data de finalització de les pràctiques."
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Invalid internship dates. the start date should be before the end date."
		}
	},
	"28": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La contraseña no es segura"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "La contrasenya no és segura."
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "The password is not secure"
		}
	},
	"29": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya hay un contacto registrado en la empresa con este email"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Ja hi ha un contacte registrat a l'empresa amb aquesta adreça"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "There is already a contact registered in the Company with this email"
		}
	},
	"30": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La candidatura ya ha sido tramitada, no puedes desinscribirte"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "La candidatura ja ha estat tramitada, no podeu desinscriure-us-hi"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Your application has already been processed; therefore, it is no longer possible to withdraw"
		}
	},
	"31": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se encuentra la candidatura"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No es troba la candidatura"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "The application cannot be found"
		}
	},
	"32": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Lo sentimos, estás dado de baja del servicio y no puedes inscribirte a ofertas"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Ens sap greu, estau donat de baixa del servei i no podeu inscriure-us a ofertes"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "We are sorry, but you are currently unsubscribed from the service and therefore cannot apply for any offer"
		}
	},
	"33": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El cif no tiene formato correcto"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "El CIF no té el format correcte"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "The CIF you entered does not match the required format"
		}
	},
	"34": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El permiso de trabajo es obligatorio para usuarios con nacionalidad distinta a los 28 países de la Unión Europea"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "El permís de treball és obligatori per a usuaris amb nacionalitat diferent de la dels 28 països de la Unió Europea"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Possession of a valid work permit is required for individuals who do not hold the nationality of one of the countries"
		}
	},
	"35": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no es accesible.",
			"to": '/'
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'enquesta no és accessible.",
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "The survey is not accessible.",
			"to": '/'
		}
	},
	"36": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no es para usuarios existentes.",
			"to": '/'
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'enquesta no és per a usuaris existents",
			"to": '/'
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "The survey is not intended for existing users.",
			"to": '/'
		}
	},
	"37": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La encuesta no permite acceso anónimo. Intentan entrar como anonimo pero no se puede.",
			"to": '/'
		},
		"ca": {
			titulo : "Error",
			cuerpo : "La encuesta no permite acceso anónimo. Intentan entrar como anonimo pero no se puede.",
			to : '/'
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Anonymous access to the survey is not allowed. some users are trying to access anonymously, but it is not permitted.",
			"to": '/'
		}
	},
	"38": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": " Atención. La encuesta a la que estás tratando de acceder ya no está disponible para tu perfil. No estas en el target de la encuesta.",
			"to": '/'
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Atenció. L'enquesta a la qual intentau accedir ja no està disponible per al vostre perfil. No sou al target de l'enquesta.",
			to : '/'
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Notice: this survey is not longer available to you. your profile does not match the intended target group",
			"to": '/'
		}

	},
	"39": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Ya has contestado esta encuesta",
			"to": '/'
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Ja heu contestat aquesta enquesta",
			to : '/'
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "You have already completed this survey",
			"to": '/'
		}
	},
	"40": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "Faltan preguntas por contestar"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Falten preguntes per contestar"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Some questions have not been answered"
		}
	},
	"42": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El enlace está caducado o ya ha sido utilizado"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'enllaç està caducat o ja ha estat utilitzat"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "This link is no longer valid or has already been used"
		}
	},
	"41": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se encuentran los estudios de la titulación indicada"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "No es troben els estudis de la titulació indicada"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "No academic records found for the specified degree programme"
		}
	},
	"44": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El email indicado pertenece a otra empresa, indique otro."
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'adreça electrònica indicada pertany a una altra empresa. Facilitau-ne una altra."
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "The provided email address is associated with another organization, please enter a different one."
		}
	},
	"46": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "La extensión del archivo no esta permitida"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'extensió de l'arxiu no està permesa"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Unsupported file extension"
		}
	},
	"48": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "La operación no está permitida"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'operació no està permesa"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Action not permitted"
		}
	},
	"49": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Esta práctica no puede cambiar de estado"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "Aquesta pràctica no pot canviar d'estat"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "The status of this internship cannot be changed"
		}
	},
	"50": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "El usuario con el que te has logado no tiene permitido el acceso al Portal de Tutores, por favor, contacta con nosotros para habilitar el acceso"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "L'usuari amb qui t'has aconseguit no té permès l'accés al Portal de Tutors, si us plau, contacta amb nosaltres per habilitar l'accés"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Access to the Tutor Portal is not allowed for your user account. Please contact us to enable access"
		}
	},
	"66": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "El Documento de Identidad no tiene formato válido"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "El document d'identitat no té un format vàlid"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Invalid ID format"
		}
	},
	"103": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Práctica no encontrada"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Internship record not found"
		}
	},
	"104": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "La titulación no es válida"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Invalid degree"
		}
	},
	"106": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "Fichero enviado erróneo"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Invalid file"
		}
	},
	"107": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "No se ha podido enviar el fichero"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "File upload failed"
		}
	},
	"108": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enviado",
			"cuerpo": "Turnitin revisará el documento y le mostraremos el resultado"
		},
		"en": {
			"titulo": "Sent",
			"cuerpo": "Turnitin will analyze the document. results will be displayed once ready"
		}
	},
	"110": {
		"categoria": 'medium',
		"es": {
			"titulo": "Error",
			"cuerpo": "No puede cerrar la práctica hasta que se formalice el anexo"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "You cannot close the internship until the annex has been formalized"
		}
	},
	"500": {
		"categoria": 'secondary',
		"es": {
			"titulo": "Error",
			"cuerpo": "El servicio actualmente no esta disponible"
		},
		"ca": {
			titulo : "Error",
			cuerpo : "El servei actualment no està disponible"
		},
		"en": {
			"titulo": "Error",
			"cuerpo": "Service Unavailable"
		}
	},
	"501": {
		"categoria": 'medium',
		"es": {
			"details": "Practica que pasa de pendiente de evaluar a evaluada",
			"titulo": "Enhorabuena",
			"cuerpo": "La práctica ha sido evaluada correctamente. Se informará al alumno que su práctica ha sido calificada y que dispone de un plazo de 3 días para revisiones.",
			"to": "/tutorados/en-evaluacion"
		},
		"ca": {
			details : "Pràctica que passa de pendent d'avaluar a avaluada",
			titulo : "Enhorabona",
			cuerpo : "La pràctica ha estat marcada com a avaluada correctament",
			to : "/tutorats/en-avaluació"
		},
		"en": {
			"details": "Internship that goes from pending evaluation to evaluated",
			"titulo": "Congratulations",
			"cuerpo": "Internship successfully evaluated. The student will be notified and given 3 days to request a review of the evaluation.",
			"to": "/tutorados/en-evaluacion"
		}
	},
	"502": {
		"categoria": 'medium',
		"es": {
			"details": "Practica se valida o se rechaza",
			"titulo": "Enhorabuena",
			"cuerpo": "Estado cambiado correctamente",
			"to": "/validaciones/pendientes"
		},
		"ca": {
			details : "La pràctica es valida o es rebutja",
			titulo : "Enhorabona",
			cuerpo : "Estat canviat correctament",
			to : "/validacions/pendents"
		},
		"en": {
			"details": "Internship is validated or rejected",
			"titulo": "Congratulations",
			"cuerpo": "Status updated successfully",
			"to": "/validaciones/pendientes"
		}
	},
	"503": {
		"categoria": 'medium',
		"es": {
			"details": "Practica que pasa de evaluada a pendiente de evaluar",
			"titulo": "Enhorabuena",
			"cuerpo": "La práctica ha sido marcada como pendiente de evaluar correctamente",
			"to": "/tutorados/evaluados"
		},
		"ca": {
			details : "Pràctica que passa d'avaluada a pendent d'avaluar",
			titulo : "Enhorabona",
			cuerpo : "La pràctica ha estat marcada com a pendent d'avaluar correctament",
			to : "/tutorats/avaluats"
		},
		"en": {
			"details": "Internship that goes from evaluated to pending evaluation",
			"titulo": "Congratulations",
			"cuerpo": "Internship status successfully set to 'pending Evaluation'",
			"to": "/tutorados/evaluados"
		}
	},
	"504": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Se ha enviado a tu email un correo para reestablecer tu contraseña",
			"to": "/login"
		},
		"ca": {
			titulo : "Enhorabona",
			cuerpo : "S'ha enviat al vostre correu un missatge per restablir la contrasenya",
			to : "/login"
		},
		"en": {
			"titulo": "Congratulations",
			"cuerpo": "An email has been sent to you to reset your password",
			"to": "/login"
		}
	},
	"505": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "Tu contraseña ha sido restablecida",
			"to": "/login"
		},
		"ca": {
			titulo : "Enhorabona",
			cuerpo : "S'ha restablert la contrasenya",
			to : "/login"
		},
		"en": {
			"titulo": "Congratulations",
			"cuerpo": "Your password has been reset",
			"to": "/login"
		}
	},
	"506": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enhorabuena",
			"cuerpo": "La oferta ha sido actualizada correctamente",
		},
		"ca": {
			titulo : "Enhorabona",
			cuerpo : "L'oferta ha estat actualitzada correctament",
		},
		"en": {
			"titulo": "Congratulations",
			"cuerpo": "The offer has been updated successfully"
		}
	},
	"507": {
		"categoria": 'medium',
		"es": {
			"titulo": "Enviado",
			"cuerpo": "El cuestionario ha sido enviado correctamente",
		},
		"ca": {
			titulo : "Enviat",
			cuerpo : "El qüestionari ha estat enviat correctament",
		},
		"en": {
			"titulo": "Sent",
			"cuerpo": "Questionnaire submitted successfully"
		}
	},

}



// WEBPACK FOOTER //
// ./src/errors/index.js